import { useEffect } from 'react';
import { useBffApiRequest } from '@/hooks/useBffApiRequest';
import { BffStaticTextContentResponse, CmsStaticTextContentType } from '@lucky7ventures/bff-types';
import BffApiService from '@/shared/bffApiService';
import { useSelector } from 'react-redux';
import { selectBtag } from '@/store/selectors/commonSelectors';

export const useBonusTermsAndConditionsLoader = () => {
  const btag = useSelector(selectBtag);
  const { request, data, loading } = useBffApiRequest<BffStaticTextContentResponse>();

  useEffect(() => {
    request({
      apiMethod: BffApiService.getStaticTextContent,
      axiosConfig: { params: { contentType: CmsStaticTextContentType.bonusTerms, btag } },
    });
  }, [btag]);

  return { tcData: data, tcLoading: loading };
};
